'use client';
// src/components/region-status/helpers.ts
var isSnackbar = (item) => item.type === "snackbar";

export { isSnackbar };
